var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPermitReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.317 13.8712H4.36502L2 11.3825V2.69153H10.317V13.8712Z",
    stroke: "#495057",
    strokeWidth: 0.7037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79346 1.75827V1H12.0119L12.0907 12.0825H11.2433",
    stroke: "#495057",
    strokeWidth: 0.7037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.3825L4.40444 11.3436L4.36502 13.8712",
    stroke: "#495057",
    strokeWidth: 0.7037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56207 4.57751H9.23299",
    stroke: "#495057",
    strokeWidth: 0.541308
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86719 5.93854H9.23304",
    stroke: "#495057",
    strokeWidth: 0.541308
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86719 7.2995H9.23304",
    stroke: "#495057",
    strokeWidth: 0.541308
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86719 8.66052H9.23304",
    stroke: "#495057",
    strokeWidth: 0.541308
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86719 10.0215H9.23304",
    stroke: "#495057",
    strokeWidth: 0.541308
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPermitReport);
export default __webpack_public_path__ + "static/media/Work Permit Report.2dd6d4c0ea4d2c6e62a7433b078d1f99.svg";
export { ForwardRef as ReactComponent };